import EventIcon from "@/assets/icons/EventIcon.svg";
import BroadcastIcon from "@/assets/icons/BroadcastIcon.svg";
import ActionItemIcon from "@/assets/icons/TaskIcon.svg";
import ExerciseIcon from "@/assets/icons/Exercise.svg";

export interface IAssessmentOption {
  id: string;
  name: string;
  description: string;
}

export interface IActionType {
  key: string;
  icon: string;
}

export const actionTypes: IActionType[] = [
  {
    key: "event",
    icon: EventIcon.src,
  },
  {
    key: "action-item",
    icon: ActionItemIcon.src,
  },
  {
    key: "broadcast-exercise",
    icon: ExerciseIcon.src,
  },
  {
    key: "broadcast",
    icon: BroadcastIcon.src,
  },
];

export const globalActionTypes: IActionType[] = [
  {
    key: "event",
    icon: EventIcon.src,
  },
  {
    key: "action-item",
    icon: ActionItemIcon.src,
  },
  {
    key: "broadcast-exercise",
    icon: ExerciseIcon.src,
  },
  {
    key: "broadcast",
    icon: BroadcastIcon.src,
  },
];

export const assessmentsList: IAssessmentOption[] = [
  {
    id: "TKA Pre-Op",
    name: "TKA Pre-Op",
    description:
      "30 Day VAS Pain, 60 Day VAS Pain, 90 Day VAS Pain, 120 Day ROM",
  },
  {
    id: "TKA Post-Op",
    name: "TKA Post-Op",
    description: "30 Day VAS Pain, 60 Day VAS Pain",
  },
  {
    id: "UKA Pre-Op",
    name: "UKA Pre-Op",
    description: "30 Day VAS Pain, 60 Day VAS Pain, 120 Day ROM",
  },
  {
    id: "UKA Post-Op",
    name: "UKA Post-Op",
    description:
      "30 Day VAS Pain, 60 Day VAS Pain, 90 Day VAS Pain, 120 Day ROM",
  },
];
